module.exports = __webpack_public_path__ + "img/background_authentication.d6248dd3.png";